import { render } from "./LogoSvg.vue?vue&type=template&id=f0a3b40c"
import script from "./LogoSvg.vue?vue&type=script&lang=js"
export * from "./LogoSvg.vue?vue&type=script&lang=js"
script.render = render

export default script